import { IconButton, Tooltip } from "@mui/material";
import { AttachmentActionProps } from "./AttachmentActionProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAlertService from "@mirage/hooks/useAlertService";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";

export interface ReadAttachmentActionProps extends AttachmentActionProps {
    setRequestedPdfUrl: (value: React.SetStateAction<string>) => void;
}
export const ReadAction = ({ setRequestedPdfUrl, onDownload, attachmentId }: ReadAttachmentActionProps) => {
    const showAlert = useAlertService();
    return (
        <Tooltip title="Read">
            <IconButton onClick={onReadPdfClicked}>
                <FontAwesomeIcon icon={MirageTheme.icons.eyeIcon} style={MirageTheme.icons.sizeS} />
            </IconButton>
        </Tooltip>
    );

    async function onReadPdfClicked() {
        const downloadResult = await onDownload(attachmentId);
        if (downloadResult) {
            location.hash = "readDocument";
            setRequestedPdfUrl(downloadResult.url.replace("/download", "/show"));
        } else {
            showAlert("Failed to download attachment", "error");
        }
    }
};
